// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panelContent[data-v-203380f5] {\n  height: calc(100% - 0.22396rem);\n  color: #fff;\n}\n.lefts[data-v-203380f5] {\n  height: 40%;\n  margin-bottom: 0.05208rem;\n}\n.lefts2[data-v-203380f5] {\n  height: calc(30% - 0.05208rem);\n  margin-bottom: 0.05208rem;\n}\n.lefts3[data-v-203380f5] {\n  height: 30%;\n}\n@media (min-height: 1400px) {\n.rightBar[data-v-203380f5] .side {\n    width: 24% !important;\n}\n}\n", ""]);
// Exports
module.exports = exports;
